<template>
  <div>
    <search
      :title="`${$t('modal.buyer')}`"
      :items="buyers"
      idProperty="EmployeeId"
      nameProperty="EmployeeName"
      @triggerClick="triggerClick"
      @remove="remove"
      :searchItems="searchItems"
    />
    <employee-select
      :isMultiple="true"
      :trigger="trigger"
      :defaultItems="defaultItems"
      @onSaved="add"
    />
  </div>
</template>

<script>
import search from "./Search";
import employeeSelect from "@/components/selects/EmployeeSelects";

export default {
  data() {
    return {
      trigger: false,
      buyers: [],
      defaultItems: undefined,
    };
  },
  props: {
    searchItems: {
      type: Object,
      default: () => ({}),
    },
  },
  watch: {
    searchItems(value) {
      if (JSON.parse(sessionStorage.getItem("isSamePage")) && value.Buyer) {
        this.buyers = value.Buyer;
      }
    },
  },
  components: {
    search,
    employeeSelect,
  },
  methods: {
    triggerClick() {
      this.defaultItems = [...this.buyers];
      this.trigger = !this.trigger;
    },
    add(items) {
      this.buyers = items;
      this.set();
    },
    remove(index) {
      if (!this.buyers[index]) return;
      this.buyers.splice(index, 1);
      this.set();
    },
    set() {
      this.$emit("set", this.buyers);
    },
  },
};
</script>
